// utils modules
import axios from '@/api/http_client';
import {getToken} from '@/common'

import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';

export const getSubDomain = () => {
  const { hostname } = window.location;
  const regexParse = new RegExp('[a-z-0-9]{2,63}.[a-z.]{2,5}$');
  const urlParts = regexParse.exec(hostname);
  return hostname.replace(urlParts[0], '').slice(0, -1);
};

export const isUserAuthenticated = () => {
  if (getSubDomain() === touristEntryPoint) {
    // if on tour.domain.com treat user as non-authenticated and use local cart
    return false;
  }
  return getToken() !== null;
};

function cleanForLanguage(dirtyProduct) {
  const product = { ...dirtyProduct };
  const temp = product.name;
  product.name = product.description;
  product.description = temp;
  return product;
}

export const getLocalCart = (callback = () => {}) => {
  let cartProductsList = JSON.parse(localStorage.getItem('cart')) || [];
  if (getLanguage() !== 'en') {
    cartProductsList = cartProductsList.map(product => cleanForLanguage(product));
  }
  callback(cartProductsList);
};

export const clearLocalCart = (callback = () => {}) => {
  const emptyCartList = [];
  setLocalCart(emptyCartList, callback);
};

export const isNumericInput = (event) => {
  const key = event.keyCode;
  return ((key >= 48 && key <= 57) || // Allow number line
      (key >= 96 && key <= 105) // Allow number pad
  );
};

export const isModifierKey = (event) => {
  const key = event.keyCode;
  return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
      (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
      (key > 36 && key < 41) || // Allow left, up, right, down
      (
          // Allow Ctrl/Command + A,C,V,X,Z
          (event.ctrlKey === true || event.metaKey === true) &&
          (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
      )
};

export const enforceFormat = (event) => {
  // Input must be of a valid number format or a modifier key, and not longer than ten digits
  if(!isNumericInput(event) && !isModifierKey(event)){
      event.preventDefault();
  }
};

export const formatToPhone = (event, cb) => {
  if(isModifierKey(event)) {return;}

  const input = event.target.value.replace(/\D/g,'').substring(0,10); // First ten digits of input only
  const areaCode = input.substring(0,3);
  const middle = input.substring(3,6);
  const last = input.substring(6,10);

  if(input.length > 6){event.target.value = `(${areaCode}) ${middle} - ${last}`;}
  else if(input.length > 3){event.target.value = `(${areaCode}) ${middle}`;}
  else if(input.length > 0){event.target.value = `(${areaCode}`;}

  if (cb) {
    cb();
  }
};

/*
  cleanObject
    takes in an object and returns a new object based on the desiredShape
  parameters:
    obj: object to clean
    desiredShape: transformation object:
      ex)
      {
        id: 'SalesOrder_id', // this will have the value of obj.SalesOrder_id
        nestedExample: 'cars.honda.accord',
        fullName: obj => `${obj.FirstName} ${obj.LastName}`,
        products: obj => obj.Product_Line_List.map(product => {name: product.Name})
      }
  returns:
    new object with transformed shape or original shape if desiredShape is an empty object
*/
export const cleanObject = (obj, desiredShape) => {
  if (isEmpty(desiredShape)) {
    return obj;
  }
  return transform(obj, desiredShape);
};

// initial state
const state = {
}

// actions
const actions = {
};

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/utils.js